import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';

interface HistoryItem {
    id: number;
    date: string;
    change: string;
}

interface Props {
    history: HistoryItem[];
    comment?: string;
    onCommentChange?: (comment: string) => void;
    onSave?: () => void;
}

export default function CommentHistoryPopup({
    history,
}: Props) {
    return (
        <div className="px-4 pb-2">
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th style={{ width: '160px' }}>Data</th>
                        <th>Pastabos</th>
                    </tr>
                </thead>
                <tbody>
                    {[...history]
                        .reverse()
                        .map((item) => (
                            <tr key={`hist-${item.id}`}>
                                <td className="whitespace-nowrap">
                                    {moment(item.date).format('YYYY-MM-DD HH:mm')}
                                </td>
                                <td style={{
                                    maxWidth: '200px',
                                    overflowWrap: 'break-word',
                                    wordBreak: 'normal',
                                    whiteSpace: 'normal',
                                    hyphens: 'auto'
                                }}>
                                    {item.change}
                                </td>
                            </tr>
                        ))}
                    {history.length === 0 && (
                        <tr>
                            <td colSpan={2} className="text-center py-4 text-muted">
                                Nėra komentarų istorijos
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
}